const SQUARE_ASPECTS = [
  'twitter_square',
  'generic_square',
  'facebook_square',
  'linkedin_square',
  'instagram_square',
  'facebook_carusel',
  'facebook_square_articles'
];

const HORIZONTAL_ASPECTS_16_9 = [
  'youtube_bumper',
  'youtube_mid_roll',
  'youtube_skippable',
  'linkedin_video_ad',
  'youtube_horizontal',
  'twitter_horizontal',
  'facebook_in_stream',
  'generic_horizontal',
  'facebook_horizontal',
  'linkedin_horizontal',
  'youtube_non_skippable',
  'facebook_horizontal_articles'
];

const VERTICAL_ASPECTS_9_16 = [
  'instagram_igtv',
  'instagram_story',
  'facebook_portrait',
  'linkedin_portrait',
  'generic_vertical_full'
];

export const VERTICAL_ASPECTS_2_3 = [
  'generic_vertical',
  'facebook_vertical',
  'linkedin_vertical'
];

export const VERTICAL_ASPECTS_4_5 = [
  'instagram_feed',
  'generic_vertical_low',
  'facebook_vertical_feed',
  'linkedin_vertical_feed'
];

export const HORIZONTAL_ASPECT_4_3 = 'generic_standard';

export const FACEBOOK_COVER_ASPECT = 'facebook_cover'; // 1684:624

export const SQUARE_ASPECTS_STRING = SQUARE_ASPECTS.join(',');
export const HORIZONTAL_ASPECTS_STRING = HORIZONTAL_ASPECTS_16_9.join(',');
export const VERTICAL_ASPECT_STRING = VERTICAL_ASPECTS_9_16.join(',');

export type AspectRatioLabel =
  | 'square'
  | 'vertical'
  | 'horizontal'
  | 'story-IGTV'
  | 'facebook-cover';

export type AspectRatio = '16:9' | '9:16' | '1:1' | '4:5' | '1684:624';

export const ASPECT_MAP: { [key in AspectRatioLabel]: string } = {
  square: SQUARE_ASPECTS_STRING,
  'story-IGTV': VERTICAL_ASPECT_STRING,
  vertical: VERTICAL_ASPECTS_4_5.join(','),
  'facebook-cover': FACEBOOK_COVER_ASPECT,
  horizontal: HORIZONTAL_ASPECTS_STRING
};

export const RATIO_ASPECT_LABEL_MAP: {
  [key in AspectRatio]: AspectRatioLabel;
} = {
  '1:1': 'square',
  '4:5': 'vertical',
  '9:16': 'story-IGTV',
  '16:9': 'horizontal',
  '1684:624': 'facebook-cover'
};
